import React, { useContext, useEffect, useState } from "react";
import classnames from "classnames";
import "./toggle.scss";
import ResetState from "./resetstate";
import { GrigoraEditorContext } from "../editor/context";

function ToggleInput({
  value,
  onChange,
  className,
  palette = [],
  label = "",
  resetValue,
  isResponsive = false,
  valueTablet,
  setValueTablet,
  resetValueTablet,
  valueMobile,
  setValueMobile,
  resetValueMobile,
  isResetVisibile = true,
}) {
  const [active, setActive] = useState("desktop");
  const editorContext = useContext(GrigoraEditorContext);

  if (value === undefined || value === null) {
    value = false;
  }
  if (valueTablet === undefined || valueTablet === null) {
    valueTablet = false;
  }
  if (valueMobile === undefined || valueMobile === null) {
    valueMobile = false;
  }

  useEffect(() => {
    if (editorContext?.displaySize && isResponsive) {
      setActive(editorContext.displaySize);
    }
  }, [editorContext?.displaySize]);

  const classes = classnames(
    "grigora-toggle-input text-grigora-base mb-2 flex items-center select-none justify-end",
    className,
  );

  return (
    <div className={classes}>
      {label && (
        <div className="grigora-toggle-input__label flex flex-1">{label}</div>
      )}
      <div className="flex items-center gap-2">
        {isResetVisibile && (
          <ResetState
            active={
              (value !== resetValue && value != "") ||
              (valueTablet !== resetValueTablet && valueTablet != "") ||
              (valueMobile !== resetValueMobile && valueMobile != "")
            }
            onClick={() => {
              onChange(resetValue);
              if (isResponsive) {
                setActive("desktop");
                setValueTablet(resetValueTablet);
                setValueMobile(resetValueMobile);
              }
            }}
          />
        )}
        <label className="switch">
          <input
            type="checkbox"
            checked={
              active === "desktop"
                ? !!value
                : active === "tablet"
                ? !!valueTablet
                : !!valueMobile
            }
            onChange={(e) => {
              if (active === "desktop") {
                onChange(e.target.checked);
              } else if (active === "tablet") {
                setValueTablet(e.target.checked);
              } else setValueMobile(e.target.checked);
            }}
          />
          <span className="slider round"></span>
        </label>
      </div>
    </div>
  );
}

export default ToggleInput;
